import { useState } from 'react';

import {
  useFormik,
} from 'formik';
import * as yup from 'yup';
import {
  Button,
  TextField,
  Typography,
  FormControl,
  CircularProgress,
} from '@mui/material';
import { useResendVerificationEmailMutation } from '../../../../../graphql/generated/graphql';

import { Authentication, EmailForm } from '../../../../config/interfaces';
import MsgVerify from '../../../components/onbording/msg-verify';

const FormVerifyPage = (_props: Authentication) => {
  const { token } = _props;
  const [verifyNew] = useResendVerificationEmailMutation();
  const [loader, setLoader] = useState(false);
  const [veri, setVeri] = useState(true);
  const [email, setEmail] = useState('');

  const initialValues: EmailForm = {
    email: '',
  };
  const VerifyEmailSchema = yup.object().shape({
    email: yup.string()
      .email('Invalid email')
      .required('Required'),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: VerifyEmailSchema,
    onSubmit: async (variables) => {
      setLoader(true);
      setEmail(variables.email);
      try {
        await verifyNew({
          variables,
        });
        setVeri(false);
      } catch (e) {
        setVeri(true);
      }
      setLoader(false);
    },
  });

  return (
    <>
      <Typography
        component="h2"
        variant="h2"
        sx={{
          mb: 6,
        }}
      >
        Verify Email
      </Typography>
      { veri
        ? (
          <>
            { token
              && (
                <Typography
                  component="p"
                  variant="body2"
                  sx={{
                    mb: 2,
                  }}
                >
                  Your token has expired we have to send another message to verify you.
                </Typography>
              )}
            <FormControl
              fullWidth
              component="form"
              onSubmit={formik.handleSubmit}
            >
              <TextField
                autoFocus
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                {loader ? <CircularProgress color="primary" /> : 'Continue'}
              </Button>
            </FormControl>
          </>
        ) : <MsgVerify email={email} />}
    </>
  )
};

export default FormVerifyPage;
